import React from 'react'

export default function PostMetaItem({ className, url, item, prefix }) {
  if (!item) return null

  return url ? (
    <span className={className}>
      <a href={url}>
        {item}
        <span> &gt;</span>
      </a>
    </span>
  ) : (
    <span className={className}>
      {prefix && <span>{`${prefix}: `}</span>}
      {item}
    </span>
  )
}
